/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import IframeResizer from 'iframe-resizer-react';
import { FluidImage as ImageType } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';
import Text, { TEXT_TYPES } from '../text';

// Styles
import usePardotUrl from '../../hooks/usePardotUrl';
import { baseStyle } from './style';
import { Helmet } from 'react-helmet';
import { stringToReactComponent } from '../../helpers/general';

export interface heroV3WithFormProps {
  className?: string;
  title?: string;
  image: ImageType;
  pardotUrl?: string;
  sameSizeCol?: boolean;
  customForm?: {
    content?: string;
    script?: {
      enable?: boolean;
      value?: string;
    };
  };
}

const heroV3WithForm: FunctionComponent<heroV3WithFormProps> = React.memo(
  ({
    title,
    customForm,
    image,
    pardotUrl,
    className,
    sameSizeCol,
  }: heroV3WithFormProps) => {
    const id = React.useMemo(
      () => `kenna-pardot-form-${Math.round(Math.random() * 1000)}`,
      [],
    );
    const url = usePardotUrl(pardotUrl);

    return (
      <Box
        className={classNames('HeroV3WithForm', className)}
        sx={baseStyle.mainContainer}
      >
        {title && (
          <Text type={TEXT_TYPES.H1_BOLD} sx={baseStyle.title}>
            {title}
          </Text>
        )}
        <Flex sx={baseStyle.mainRowContainer}>
          <Flex
            sx={{
              ...baseStyle.mainRowContainerLeft,
              ...(sameSizeCol ? baseStyle.sameSizeColumn : {}),
            }}
          >
            <FluidImage {...image} sx={baseStyle.image} />
          </Flex>

          {customForm?.content && (
            <Box sx={baseStyle.main}>
              <Box sx={baseStyle.formBg}>
                <Box>
                  {customForm?.script?.enable && customForm?.script?.value && (
                    <Helmet>{stringToReactComponent(customForm.script.value)}</Helmet>
                  )}
                  <Box dangerouslySetInnerHTML={{ __html: customForm.content }} />
                </Box>
              </Box>
            </Box>
          )}

          {!customForm?.content && url && (
            <Box
              sx={{
                ...baseStyle.mainRowContainerRight,
                ...(sameSizeCol ? baseStyle.sameSizeColumn : {}),
              }}
            >
              <Box sx={baseStyle.mainRowContainerRightBorder}>
                <Box sx={baseStyle.mainRowContainerRightInner}>
                  <IframeResizer
                    allowTransparency={true}
                    frameBorder="0"
                    id={id}
                    src={url}
                    title={title}
                  />
                </Box>
              </Box>
            </Box>
          )}
        </Flex>
      </Box>
    );
  },
);

export default heroV3WithForm;
